export default __webpack_public_path__ + "static/media/Chad.2dacd7f0.png";